import { useEffect, useState } from 'react';
import { fetchCarriersList } from '../../api/carriers';
import SearchDropdown from './searchDropdown';
interface Props {
  setSelectedCarrierId?: any;
  selectedCarrierId?: any;
  setSelectedCarrierName?: any;
  selectedCarrierCode?: any;
  setSelectedCarrierCode?: any;
  setSelectedCarrier?: any;
  label?: string;
  setHandleToggleChange?: any;
  className?: any;
  firstOption?: any;
  isAirCarrier?: boolean;
  disabled?: boolean;
}
const SelectCarrierDropdown = ({
  selectedCarrierId,
  setSelectedCarrierId,
  setSelectedCarrierName,
  selectedCarrierCode,
  setSelectedCarrierCode,
  setSelectedCarrier,
  setHandleToggleChange,
  label,
  className,
  firstOption,
  isAirCarrier,
  disabled = false,
}: Props) => {
  const [carrierList, setCarrierList] = useState<any>([]);
  const [selectedValue, setSelectedValue] = useState<any>();

  useEffect(() => {
    let payload = {
      is_pagination: false,
    };
    fetchCarriersList(payload)
      ?.then((response) => {
        if (!response?.data?.is_error) {
          let carriersData = response?.data?.content;
          if (selectedCarrierCode) {
            let selectedCarrier = response?.data?.content.filter(
              (item: any) => item.code === selectedCarrierCode
            );
            setSelectedValue(selectedCarrier);
          }
          if (selectedCarrierId) {
            let selectedCarrier = response?.data?.content.filter(
              (item: any) => item.id === selectedCarrierId
            );
            setSelectedValue(selectedCarrier);
          }
          const formattedCarriersList: any = carriersData
            .filter((item: any) => !isAirCarrier || item?.mode_name === 'Air')
            .map((item: any) => ({
              label: item?.name,
              value: item,
            }));
          setCarrierList(formattedCarriersList);
        }
      })
      .catch((e) => {});
  }, []);

  return (
    <SearchDropdown
      id={'carrier-dropdown'}
      placeholder={label ? label : 'All Carriers'}
      selectedValue={selectedValue}
      label={label && label}
      dummyOptionText={firstOption ? firstOption : 'All Carriers'}
      options={carrierList && carrierList}
      className={className && className}
      onSelect={(item) => {
        if (!disabled) {
          setSelectedCarrierId && setSelectedCarrierId(item.value?.id);
          setSelectedCarrierCode && setSelectedCarrierCode(item.value?.code);
          setSelectedCarrier && setSelectedCarrier(item.value);
          setSelectedCarrierName && setSelectedCarrierName(item.value?.name);
          setHandleToggleChange && setHandleToggleChange(true);
        }
      }}
      isDisabled={disabled}
    />
  );
};

export default SelectCarrierDropdown;
